/**
 * Legacy payroll redirects — `/c1/workers/payroll` and
 * `/c1/workers/payroll/:evereeTenantId` → the current `/earnings` routes.
 *
 * These are the paths SERVER-SENT links still use
 * (functions/src/utils/workerUrls.ts, messaging/systemMessageDispatcher.ts), so
 * they are the ones workers actually tap out of a text or notification.
 *
 * ☠️ Both used to drop `location.search`/`hash`. Any query on a payroll link
 * died at the redirect — `?view=tax` (the Pay tab's tax-forms intent) silently
 * degraded to Everee's full worker home. Reproduced live 2026-09-14:
 * `/c1/workers/payroll/3138?view=tax` landed on `/c1/workers/earnings/3138`
 * with no query. Extracted here so the preservation is unit-tested rather than
 * re-broken the next time someone touches App.tsx.
 */
import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/** `/c1/workers/payroll` → `/c1/workers/earnings` (query + hash preserved). */
export function WorkerPayrollIndexLegacyRedirect(): React.ReactElement {
  const location = useLocation();
  return <Navigate to={`/c1/workers/earnings${location.search}${location.hash}`} replace />;
}

/** `/c1/workers/payroll/:evereeTenantId` → `/c1/workers/earnings/:evereeTenantId`. */
export function WorkerPayrollLegacyRedirect(): React.ReactElement {
  const { evereeTenantId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`/c1/workers/earnings/${evereeTenantId ?? ''}${location.search}${location.hash}`}
      replace
    />
  );
}
